<template>
  <v-container v-if="item">
    <toolbar mode="export" :item="item" @clone="onClone" @delete="onDelete">
      <ax-button v-if="isOwner(item)" icon="mdi-refresh" tooltip="Refresh" confirm @confirmed="onUpdate" />
      <ax-button 
        icon="mdi-arrow-down"
        tooltip="Download"
        :disabled="!isOwner(item)"
        @clicked="onDownload"
      />
    </toolbar>
    <v-card flat>
      <v-tabs v-model="tab">
        <v-tab :disabled="item.status !== 'SUCCESS'" href="#data">Data</v-tab>
        <v-tab :disabled="item.status !== 'SUCCESS'" href="#info">Info</v-tab>
        <v-tab href="#result">Result</v-tab>
        <v-tab href="#logs">Logs</v-tab>
        <v-tab href="#details">Details</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item value="data">
          <frame-head :items="head" @load="onLoad" />
        </v-tab-item>
        <v-tab-item value="info">
          <frame-info :items="info" />
        </v-tab-item>
        <v-tab-item value="result">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Task</v-col>
              <v-col>{{ item.result.task_name }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Status</v-col>
              <v-col>{{ item.result.status }}</v-col>
            </v-row>
            <v-row dense v-if="item.result.status == 'FAILURE'">
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Result</v-col>
              <v-col>{{ JSON.parse(item.result.result)['exc_type'] }}: {{ JSON.parse(item.result.result)['exc_message'].join(', ') }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Completed</v-col>
              <v-col>{{ item.result.date_done | dateFormat("LL LT") }} ({{ item.result.date_done | dateFormat }})</v-col>
            </v-row>
            <v-row dense v-if="user.is_superuser">
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Traceback</v-col>
              <v-col><pre>{{ item.result.traceback }}</pre></v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="logs">
          <v-card-text>
            <pre>{{ item.logs || 'No logs available' }}</pre>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="details">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Name</v-col>
              <v-col>
                <template v-if="item.file">
                  {{ item.file.name }} ({{ item.file.size | byteFormat }})
                </template>
                <template v-else>{{ item.uuid }}</template>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Owner</v-col>
              <v-col>{{ item.owner.name }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Created</v-col>
              <v-col>{{ item.created_at | dateFormat("LL LT") }} ({{ item.created_at | dateFormat }})</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Updated</v-col>
              <v-col>{{ item.updated_at | dateFormat("LL LT") }} ({{ item.updated_at | dateFormat }})</v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import AxButton from "@/components/button"
import AxStatus from "@/components/status"
import frameHead from "@/components/head"
import frameInfo from "@/components/info"
import toolbar from "@/components/toolbar"
import Exports from "@/api/exports"
export default {
  name: "Export",
  components: {
    frameHead,
    frameInfo,
    toolbar,
    AxButton,
    AxStatus
  },
  data() {
    return {
      item: null,
      head: {
        data: [],
        schema: {},
      },
      info: {
        data: [],
        schema: {}
      },
      headLoaded: false,
      headLoading: false
    }
  },
  created() {
    Exports.retrieve(this.$route.params.uuid).then(response => {
      this.item = response.data
      if (this.item.status == 'SUCCESS') {
        Exports.info(this.$route.params.uuid).then(response => this.info = typeof response.data == "string" ? JSON.parse(response.data) : response.data)
        this.onLoad()
      }
    })
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ hash: tab })
      },
      get () {
        return this.$route.hash.replace('#', '')
      }
    },
  },
  methods: {
    onLoad() {
      if (this.headLoaded || this.headLoading) {
        return
      }
      
      this.headLoading = true
      Exports.head(this.$route.params.uuid, this.head.data.length)
        .then((response) => {
          let head = typeof response.data == "string" ? JSON.parse(response.data) : response.data
          if (head.data && head.data.length > 0) {
            if (this.head.data.length === 0) {
              this.$set(this.head, 'data', head.data)
            } else {
              this.head.data.push(...head.data)
            }
            if (head.schema && Object.keys(head.schema).length > 0) {
              this.$set(this.head, 'schema', head.schema)
            }
            if (head.data.length < 50) {
              this.headLoaded = true
            }
          } else {
            this.headLoaded = true
          }
        })
        .finally(() => {
          this.headLoading = false
        })
    },
    onUpdate() {
      Exports.refresh(this.$route.params.uuid).then(_ => {
        this.notify('Refreshing export...')
        this.$router.push({ name: 'exportList'})
    })
    },
    onDownload() {
      Exports.download(this.$route.params.uuid).then(response => {
        let csv = response.data
        var downloadLink = document.createElement("a")
        var blob = new Blob(["\ufeff", csv])
        var url = URL.createObjectURL(blob)
        downloadLink.href = url
        downloadLink.download = `${this.$route.params.uuid}.csv` //Name the file here
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      })
    },
    onClone(){
      Exports.clone(this.$route.params.uuid).then(_ => {
        this.notify('Export cloned')
        this.$router.push({ name: 'exportList' } )
      })
    },
    onDelete() {
      Exports.destroy(this.$route.params.uuid).then(_ => {
        this.notify('Export deleted')
        this.$router.push({ name: 'exportList' })
      })
    }
  }
}
</script>
